import React from 'react';
import Asset from '../../requests/apa/Asset';
import Utils from "../../utils/Utils";

function focusHandler(focusHandlerCallBack, data) {
  if (window.setResumeData) window.setResumeData(data);
  return typeof focusHandlerCallBack === 'function' ? focusHandlerCallBack(data) : null;
}

function keyUpHandler(keyUpHandlerCallBack, props) {
  return typeof keyUpHandlerCallBack === 'function' ? keyUpHandlerCallBack(props) : null;
}

function keyDownHandler(e, keyDownHandlerCallBack, params) {
  return typeof keyDownHandlerCallBack === 'function' ? keyDownHandlerCallBack(e, params) : null;
}

function getPlaceholder(type) {
  let placeholder = null;

  switch (type) {
    case 'highlight':
      placeholder = Asset.get(
        'asset_placeholder_highlight',
        '/images/placeholder_highlight.png'
      );
      break;
    case 'landscape':
      placeholder = Asset.get(
        'asset_placeholder_landscape',
        '/images/placeholder_landscape.png'
      );
      break;
    case 'portrait':
      placeholder = Asset.get(
        'asset_placeholder_portrait',
        '/images/placeholder_portrait.png'
      );
      break;
    case 'cd':
    case 'square':
    case 'circle':
      placeholder = Asset.get('asset_placeholder_square', '/images/placeholder_square.png');
      break;
    case 'user-profile':
    case 'user-info':
    case 'actor':
    case 'casting':
    case 'costume designer':
    case 'original music':
    case 'production design':
    case 'screenwriter':
    case 'set decoration':
    case 'art director':
    case 'supervising art direction':
    case 'executive producer':
    case 'film editor':
    case 'cinematographer':
    case 'producer':
    case 'talent':
    case 'narrator':
    case 'voice':
    case 'director':
    case 'writer':
    case 'conductor':
      placeholder = Asset.get(
        'content_data_talent_placeholder',
        '/images/content_data_talent_placeholder.png'
      );
      break;
    default:
      placeholder = Asset.get(
        'asset_placeholder_landscape',
        '/images/placeholder_landscape.png'
      );
  }

  return placeholder;
}

function getUri(href, group_id, data, ignoreSeenLast) {
  href = data.href || data.src || `/vcard/${group_id || ''}`;
  if (data.live_enabled == '1') href = `/player/${group_id}`;
  if (href.indexOf('/vcard/') !== -1) href = `${href}${ignoreSeenLast ? '/1' : ''}`;
  return href;
}

function createSibling(sibling) {
  const siblingComponent = (
    <div className="placeholder-container">
      <div className="sibling-wrapper">
        <div
          className="card-placeholder"
          style={{backgroundImage: `url(${this.getPlaceholder('portrait')})`}}
          alt="placeholder"
        />
        <img className="card-cover" src={sibling}/>
      </div>
      <div className="arrow-right"/>
    </div>
  );

  return sibling ? siblingComponent : null;
}

function createTitle(title, isTalent, groupName = '') {
  const titleComponent = isTalent ?
    <div className="card-title">
      <span>{title}</span>
      {groupName && <span className="talent-type">{groupName.toUpperCase()}</span>}
    </div>
  : <div className="card-title">{title}</div>;

  return title.length ? titleComponent : null;
}

function createLabel(label) {
  const span = <div className="card-label"
                    dangerouslySetInnerHTML={{__html: label}}/>;

  return label.length ? span : null;
}

function posterTitleIsEnabled(provider = 'default', display = 'landscape') {
  provider = provider.toLowerCase().split(' ').join('');
  let poster_title_configuration = Utils.getAPARegionalized('poster_title_configuration', provider, {
    "default": {"portrait": true, "landscape": true},
    "amco": {"portrait": false, "landscape": false},
    "fox": {"portrait": true, "landscape": true},
    "hbo": {"portrait": true, "landscape": true},
    "noggin": {"portrait": true, "landscape": true},
    "picardia": {"portrait": true, "landscape": true},
    "edye": {"portrait": true, "landscape": true},
    "paramount": {"portrait": true, "landscape": true},
    "stingrayqello": {"portrait": true, "landscape": true},
    "stingraykaraoke": {"portrait": true, "landscape": true},
    "atresplayer": {"portrait": true, "landscape": true}
  });
  if(poster_title_configuration[display]) {
    return poster_title_configuration[display];
  }
  poster_title_configuration = poster_title_configuration[provider] ? poster_title_configuration[provider] : poster_title_configuration['default'];
  return  poster_title_configuration && poster_title_configuration[display]   ?  poster_title_configuration[display] : false;
}

export default {
  getPlaceholder,
  getUri,

  createSibling,
  createTitle,
  createLabel,

  focusHandler,
  keyUpHandler,
  keyDownHandler,

  posterTitleIsEnabled
};



// WEBPACK FOOTER //
// ./src/components/Card/helpers.js